import { Component, input } from '@angular/core';
import { BOProduct, OrderEntry } from '@boels/models';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-product-in-cart-label',
  templateUrl: './product-in-cart-label.component.html',
  styleUrls: ['./product-in-cart-label.component.scss'],
  imports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: [''],
    },
  ],
})
export class ProductInCartLabelComponent {
  $orderEntry = input.required<OrderEntry | undefined>();
  $product = input.required<BOProduct>();
}
